import { LayoutList } from "lucide-react"
import { Runs, RunsToolbar, useRunsFilters } from "./Runs"
import { RunsChart } from "./RunsChart"

export function Overview({ agent, workspace_slug, runs = [], chart_runs = [], pagination = {}, filters = {} }) {
  const filterProps = useRunsFilters({ basePath: `/${workspace_slug}/agents/${agent.id}`, filters, pagination })
  const showToolbar = filterProps.hasActiveFilters || (pagination.count ?? 0) > 0

  return (
    <>
      <RunsChart runs={chart_runs} onBarClick={filterProps.handleBarDateRange} activeFrom={filterProps.from} />
      <div>
        <div className="flex items-end justify-between mb-3">
          <h2 className="text-md font-medium flex items-center gap-1.5">
            <LayoutList className="h-4 w-4 text-muted-foreground" />
            History
          </h2>
          {showToolbar && <RunsToolbar {...filterProps} />}
        </div>
        <Runs workspace_slug={workspace_slug} runs={runs} pagination={pagination} filterProps={filterProps} />
      </div>
    </>
  )
}
